import { L_STORAGE_KEYS } from '@src/consts'

type LStorageKeys = (typeof L_STORAGE_KEYS)[keyof typeof L_STORAGE_KEYS]

type SetItem = {
  key: LStorageKeys
  value: object | string
}

/**
 * for localStorage control.
 * Abstraction to restrict key name.
 * for remove dependencies localStorage.
 * Named "Lstorage" to avoid confusion with javascript Object
 * @namespace lStorage
 * @module lStorage
 */
export const lStorage = {
  getItem: (key: LStorageKeys): string | null => {
    if (typeof window === 'undefined') return ''
    return localStorage.getItem(key)
  },
  removeItem: (key: LStorageKeys): void => {
    if (typeof window === 'undefined') return
    localStorage.removeItem(key)
  },
  setItem: ({ key, value }: SetItem): void => {
    if (typeof window === 'undefined') return

    /**
     * @description
     * When converting a Date object using JSON.stringify, it produces a string that's escaped with double quotes.
     * Passing this string directly to the new Date constructor returns an invalid date, causing an error.
     * To avoid the need to parse values retrieved from localStorage unnecessarily, I've added this condition.
     */
    if (value instanceof Date) {
      localStorage.setItem(key, value.toISOString())
    } else if (typeof value === 'string') {
      localStorage.setItem(key, value)
    } else {
      localStorage.setItem(key, JSON.stringify(value))
    }
  },
}
